export default __webpack_public_path__ + "static/media/sd-event2.c8f77ff5.webp";